// Generated by GitHub Copilot

/**
 * Build an API URL from the configured base and endpoint path.
 *
 * @param {string} path Endpoint path without base URL.
 * @param {string} [baseUrl] Optional explicit base URL override.
 * @returns {string} Normalized API URL.
 */
export function buildApiUrl(path, baseUrl = import.meta.env.VITE_API_BASE_URL || "/api") {
  const trimmedBase = baseUrl.replace(/\/$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${trimmedBase}${normalizedPath}`;
}
